import { Component, OnInit } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PendientesService } from '../../../services/pendientes.service';
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { Pendiente } from '../../../models/pendiente';

@Component({
    templateUrl: './detalle-pendiente.component.html'
})

export class DetallePendienteComponent implements OnInit {

    // usuario Actual
    currentUser: any;

    // Información de pendiente
    pendiente:Observable<Pendiente>;
    pendienteId:string;

    // Información de creador y responsable
    creador:Observable<any>;
    responsable:Observable<any>;

    // Nota nueva
    nota:string;

    constructor(
        private activatedRoute:ActivatedRoute,
        private usuariosPersonalService: UsuariosPersonalService,
        private router:Router,
        private pendientesService:PendientesService) {}

    ngOnInit(): void {
        this.currentUser = this.usuariosPersonalService.auth;
        // Se obtienen los datos del parámetro de la URL
        this.activatedRoute.params.forEach((params: Params) => {
            this.pendienteId = params['id'];
            this.pendiente = this.pendientesService.obtenerPendiente(this.pendienteId).valueChanges();
            this.pendiente.subscribe((pendiente:Pendiente) => {
                this.creador = this.usuariosPersonalService.obtenerPropiedadDeUsuario(pendiente.creador, 'informacionPersonal/').valueChanges().take(1);
                this.responsable = this.usuariosPersonalService.obtenerPropiedadDeUsuario(pendiente.responsable, 'informacionPersonal/').valueChanges().take(1);
            });
            // this.af.database.list('pendientes/' + this.pendienteId + '/notas', {query:{orderByChild:'fecha'}}).subscribe((notasDB)=>{
                
            //     this.mensajes = notasDB;
            // });
            // this.pendientesSubscripcion = this.detallePendiente.subscribe((pendiente) => {
            //     if(pendiente.notas){
            //         this.misNotas = pendiente.notas.responsable;
            //         this.misNotasCreador = pendiente.notas.creador;
            //     }
                
            //     this.terminado = pendiente.terminado;
            //     this.mensajes = [];
            //     this.responsables = pendiente.responsables;
            //     this.responsables.push(pendiente.creador)
            //     for (var nota in pendiente.notas) {
            //         this.mensajes.push(pendiente.notas[nota]);
            //     }
            // });
        });
    }

    // Marca como finalizado el pendiente si es que la persona
    finalizarPendiente(){
        this.pendiente.take(1).subscribe(pendiente => this.pendientesService.marcarComoFinalizado(this.pendienteId, pendiente));
    }

    // Reabre un pndiente que previamente estaba finalizado
    reabrirPendiente(){
        this.pendiente.take(1).subscribe(pendiente => this.pendientesService.reabrir(this.pendienteId, pendiente));
    }

    // Agrega una nota en el pendiente
    agregarNota(){
        this.pendientesService.agregarNota(this.pendienteId, this.nota, this.currentUser.uid).then(() => this.nota = undefined);
    }

    // Confirma un pendiente realizado por alguien más
    confirmarPendiente(){
        if(confirm('¿Deseas marcar este pendiente como terminado?, esta acción no se puede revertir'))
            this.pendiente.take(1).subscribe(pendiente => this.pendientesService.confirmar(this.pendienteId, pendiente));
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/detalle-pendiente/detalle-pendiente.component.ts